import { CQITabID } from 'screens/Reports/CQI/tables/utils'
import { getKeys } from './getKeys'

export const cqiTranslations = {
  // Columns
  TYPE_INDICATOR: `"{{type}}" Indicator`,
  TIMEFRAME: 'Timeframe',
  OUTPUT: 'Output',
  // timeframe
  ONE_MONTH: '1 Month',
  SIX_MONTHS: '6 Months',
  PRESENT_TIME: 'Present time',
  // Safe
  [CQITabID.Safe]: 'Safe',
  AVERAGE_DAILY_ACTIVE_CARERS: 'Average daily active carers',
  INCIDENTS_RECORDED: 'Incidents recorded',
  TODOS_MISSES: "To-Do's missed",
  // Effective
  [CQITabID.Effective]: 'Effective',
  SIGNED_SUPPORT_PLANS: 'Signed Support Plans',
  // Caring
  [CQITabID.Caring]: 'Caring',
  CLIENTS_NOTES_SECTIONS_COMPLETED: "Clients 'Notes' sections completed",
  CLIENTS_PERSONAL_DETAILS_COMPLETED: "Clients 'Personal details' completed",
  CLIENTS_WITH_PROFILE_PICTURES: 'Clients with profile pictures',
  // Responsive
  [CQITabID.Responsive]: 'Responsive',
  SUPPORT_PLANS_COMPLETED: 'Support Plans completed',
  SUPPORT_PLANS_IN_DATE: 'Support Plans in date',
  CLIENTS_WITH_EOL_SUPPORT_PLANS: 'Clients with EOL Support Plans',
  // Well led
  [CQITabID.WellLed]: 'Well-led',
  STAFF_WITH_PROFILE_PICTURES: 'Staff with profile pictures',
  SUPPORT_PLANS_REVIEWED: 'Support Plans reviewed'
}

export const cqiConstants = getKeys(cqiTranslations)
